import { z } from 'zod';

import { PlatformUserRole } from '@nucleus-commerce/api-client/platform';

const required = { error: 'users:validation.required' };

/** Form behind POST /platform/v1/users. No password: the person sets one from the emailed link. */
export const createUserSchema = z.object({
  email: z.email({ error: 'users:validation.email' }),
  name: z.string().trim().min(1, required).max(120, { error: 'users:validation.nameMax' }),
  role: z.enum(PlatformUserRole),
});

export type CreateUserInput = z.input<typeof createUserSchema>;
export type CreateUserOutput = z.output<typeof createUserSchema>;

export function emptyCreateUserForm(): CreateUserInput {
  return { email: '', name: '', role: 'support' };
}
